precision highp float;

varying vec2 vUv;
uniform sampler2D tDiffuse;
uniform vec2 direction;
uniform vec2 resolution;
uniform float radius;

    float gaussian(float x, float sigma){
      return exp(-0.5 * (x*x) / (sigma*sigma));
    }

    void main(){
      vec2 px = 1.0 / resolution;
      vec4 sum = vec4(0.0);
      float wsum = 0.0;
      for(int i=-4; i<=4; i++){
        float w = gaussian(float(i), radius);
        vec2 off = direction * float(i);
        vec4 s = texture2D(tDiffuse, vUv + off);
        sum += s * w;
        wsum += w;
      }
      gl_FragColor = sum / wsum;
    }